import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
// import * as Yup from 'yup'; // لإضافة التحقق من البيانات إذا لزم الأمر
import Select from 'react-select';
import useGetGlLedgersList from '../../../../hooks/Finance/useGetGlLedgersList';
import { useTranslation } from 'react-i18next';
import useGetGlPeriodsList from '../../../../hooks/Finance/GlPeriods/useGetGlPeriodsList';
import {
  createAccountPayroll,
  // GetPayrollActionList,
} from '../../../../store/HR/Payroll/runPayrollSlice';
import { useAppDispatch } from '../../../../store/hooks';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { CreateAccountSchema } from '../../../ValidationForm/validationSchema';

interface Props {
  payrollActionId: string;
}

const CreateAccount = ({ payrollActionId }: Props) => {
  const { t, i18n } = useTranslation();
  const { OptionsLedgers } = useGetGlLedgersList();
  const { GlPeriods } = useGetGlPeriodsList();
  const dispatch = useAppDispatch();

  // إعداد نموذج formik
  const formik = useFormik({
    initialValues: {
       periodId: '',
      glDate: '',
    },
    validationSchema: CreateAccountSchema(t),
    onSubmit: (values) => {
      const body: any = {
        transections: [payrollActionId],
        periodId: values.periodId,
        ledgerId: values.ledgerId,
        glDate: values.glDate,
      };

      dispatch(createAccountPayroll(body ))
        .unwrap()
        .then((res) => {
          if (res.succeeded) {
            CustomAlert({
              action: 'info',
              msg: `تم ترحيل الراتب  للمالية `,
            });
          } else {
            CustomAlert({
              action: 'Error',
              // msg: `تم ترحيل الراتب  للمالية `,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    },
  });

  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        <div className="row">
 

          <div className="col-12">
            <div className="form-group mb-3">
              <label className="form-label">{t('AccountingPeriod')} </label>
              <Form.Select
                className="form-select form-select-lg text-center"
                name="periodId"
                value={formik.values.periodId}
                onChange={formik.handleChange}>
                <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                {GlPeriods &&
                      GlPeriods?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
              </Form.Select>
              {formik.errors.periodId && formik.touched.periodId && (
                <div className="text-danger">{formik.errors.periodId}</div>
              )}
            </div>
          </div>

          <div className="col-12">
            <div className="form-group mb-3">
              <label className="form-label">{t('التاريـخ')} </label>
              <Form.Control
                className="form-control  form-control-lg  text-center"
                type="date"
                name="glDate"
                value={formik.values.glDate}
                onChange={formik.handleChange}
              />
              {formik.errors.glDate && formik.touched.glDate && (
                <div className="text-danger">{formik.errors.glDate}</div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <button
              type="submit"
              className="btn btn-lg btn-theme  w-100 rounded-0"
              disabled={formik.isSubmitting || !formik.isValid}>
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fas fa-lg fa-fw me-2 fa-check-circle"></i>
              )}
              {t('ترحيـل')}
            </button>
          </div>
          <div className="col-6">
            <button
              type="button"
              className="btn btn-lg  btn-default   w-100 rounded-0"
              data-bs-dismiss="modal">
              <i className="fas fa-times-circle fa-fw me-1"></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateAccount;
